import { Component, Input } from '@angular/core';
import { QuestionInfo } from '../../Common/Models/Api/Info/DynamicForm/QuestionInfo';
import { DynamicFormAnswer } from './DynamicFormAnswer';

@Component({
	standalone: false,
	selector: 'dfq-multichoice',
	template: /*language=html*/ `
		<h3>
			<span>{{ data.questionNumber }}</span> {{ data.Header }} <span class="required" *ngIf="data.Required">*</span>
		</h3>
		<div class="row input" [class.dirty]="dirty">
			<visiba-input
				*ngFor="let o of options"
				type="checkbox"
				[(ngModel)]="o.value"
				(onChange)="valueChange()"
				[staticplaceholder]="o.label"
				[readonly]="readonly"
			></visiba-input>
			<span class="error" *ngIf="!valid()">{{ 'LicenceHolder.DynamicForm.Error.MultiChoiceRequired' | translate }}</span>
		</div>
	`,
})
export class DfqMultiChoiceComponent {
	@Input() formId: number = null;
	@Input() data: QuestionInfo = null;
	@Input() readonly = false;
	options: Array<{ resourceId: number; value: boolean; label: string }> = [];
	dirty: boolean = false;

	// biome-ignore lint/suspicious/noEmptyBlockStatements: suppressed due to migration - should be fixed
	constructor() {}

	ngOnInit() {
		this.options = this.data.Options.map((x) => {
			return { resourceId: x.Id, value: false, label: x.Text };
		});
		if (typeof this.data.Answer === 'undefined' || this.data.Answer === null)
			this.data.Answer = new DynamicFormAnswer(null, this.data.Id, this.valid);
		else {
			this.data.Answer.Valid = this.valid;
			this.data.Answer.Choices.forEach((c) => {
				let options = this.options.filter((x) => x.resourceId === c);
				if (options.length > 0) options[0].value = true;
			});
		}
	}

	valueChange = () => {
		this.dirty = true;
		this.data.Answer.Choices = this.options
			.filter((x) => {
				return x.value;
			})
			.map((x) => {
				return x.resourceId;
			});
	};

	valid = (): boolean => {
		return !this.data.Required || (typeof this.data.Answer.Choices !== 'undefined' && this.data.Answer.Choices.length > 0);
	};
}
